import { InputBaseComponentProps } from '@mui/material';
import React from 'react';

export const IpAddressSlot = React.forwardRef<
  HTMLInputElement,
  InputBaseComponentProps
>(function TextMaskCustom(props, ref) {
  const { onChange, value, ...other } = props;

  const handleChange = (event: React.ChangeEvent<HTMLInputElement>) => {
    let newValue = event.target.value;
    newValue = newValue.replace(/[^\d.]/g, '');
    const dots = (newValue.match(/\./g) || []).length;

    if (dots > 3) {
      return;
    }
    const octets = newValue.split('.');

    for (let i = 0; i < octets.length; i++) {
      if (octets[i].length > 0) {
        const num = parseInt(octets[i], 10);
        if (num > 255) {
          octets[i] = '255';
        }
      }
    }

    onChange(octets.join('.'));
  };

  const handleBlur = () => {
    if (!value) return;

    const octets = value.split('.');
    if (octets.length === 4) {
      const validOctets = octets.map((octet: string) => {
        return octet === '' ? '0' : octet;
      });
      onChange(validOctets.join('.'));
    }
  };

  return (
    <input
      {...other}
      ref={ref}
      value={value || ''}
      onChange={handleChange}
      onBlur={handleBlur}
      placeholder="0.0.0.0"
    />
  );
});
